import Main from '@/components/main';
import Warehouse from './warehouse';

export default {
    path: '/warehouse-management',
    name: 'warehouse-management',
    meta: {
        icon: 'ios-medical',
        title: '库存管理',
        showAlways: true,
        hideInMenu: true
    },
    component: Main,
    children: [
        ...Warehouse
    ]
};